import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class nameBulkUpdateService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public apnx_resource_url = `${this.BASE_API_URL}/common/bulk-update-name/`;
  public adsp_resource_url = `${this.BASE_ADSP_URL}/common/bulk-update-name/`;
  public bdsp_resource_url = `${this.BASE_BDSP_URL}/common/bulk-update-name/`;
  public tdsp_resource_url = `${this.BASE_TDSP_URL}/common/bulk-update-name/`;

  bulkUpdate(dsp, params = {}, data = {}) {
    let resource_url =
      dsp == "apnx"
        ? this.apnx_resource_url
        : dsp == "adsp"
        ? this.adsp_resource_url
        : dsp == "bdsp"
        ? this.bdsp_resource_url
        : this.tdsp_resource_url;
    let url = this.buildUrl(`${resource_url}`, "", params);
    return this.patch(url, data);
  }
}
